import React from 'react';
import { Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import '../../assets/styles/FeaturedBanner.css'; // External CSS file

const { Title, Paragraph } = Typography;

const FeaturedBanner = () => (
  <section className="featured-banner">
    <div className="banner-content">
      <Title level={1} style={{ color: '#fff', fontSize: '24px', marginBottom: '16px' }}>
        Unlock Your Tech Future with JectHub
      </Title>
      <Paragraph style={{ fontSize: '14px', color: '#fff', maxWidth: '800px', margin: '0 auto 24px' }}>
        Join Africa’s leading AI-powered platform for free courses, hands-on challenges, and mentorship in AI, Cybersecurity, and Data Science. Start today and build skills that employers demand!
      </Paragraph>
      <Link to="/signup">
        <Button
          size="large"
          className="get-started-button" // Add a class for specific styling
          style={{
            backgroundColor: '#fff',
            color: '#1890ff',
            border: 'none',
            fontWeight: 'bold',
          }}
        >
          Get Started Now <FaArrowRight style={{ marginLeft: '8px' }} />
        </Button>
      </Link>
    </div>
  </section>
);

export default FeaturedBanner;